import { graphql, useStaticQuery } from "gatsby"

const useNavbarQuery = () => {
  const data = useStaticQuery(graphql`
    query doublenavbar {
      SuperOps {
        navigationBlocks {
          name
          slug
          version
          order
          iconType
          isDropdown
          where
          dropdownHeader
          subDirectories
          isDropdownFooterVisible
          navigationLinks {
            heading
            subText
            image {
              url
            }
            icon {
              url
            }
            iconBgColor {
              css
            }
            link
            childFooter
            childFooterLink
            featureNavigationLinks {
              icon {
                url
              }
              iconBgColor {
                css
              }
              image {
                url
              }
              heading
              subText
              link
              childFooter
              isNew
              featureNavigationLinks {
                icon {
                  url
                }
                heading
                childFooterLink
                link
                isNew
              }
            }
            featuredItems {
              ... on SuperOps_Post {
                coverImage: featuredImage {
                  url
                }
                slug
                heading: name
                subtext: title
                footerText
              }
              ... on SuperOps_Episode {
                image {
                  url
                }
                slug
                heading: name
                subtext: title
                footerText
                superpodPage
              }
              ... on SuperOps_Webinar {
                coverImage {
                  url
                }
                webSlug: slug
                heading: name
                webSubtext: heroHeading
                footerText
              }
            }
          }
        }
        navigationContents(orderBy: order_ASC) {
          section
          isParentOnly
          parentTitle
          parentDescription
          parentTagBg
          childTitle
          childSlug
          childDescription
          childIcon {
            url
          }
          parentTagSecondaryBg
          parentSlug
        }
      }
    }
  `)

  return data
}

export default useNavbarQuery
